import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, BadgeProps } from 'antd';
import styled, { css } from 'styled-components';

export interface ClaimBadgeProps {
  status?: string;
  statusTc?: string;
  code: string;
  styles?: React.CSSProperties;
}

const borderedCss = css`
  border-width: 1px;
  border-style: solid;
  line-height: 1.5;
`;

interface StyledBadgeProps extends BadgeProps {
  claimstatus?: string;
}

const StyledBadge = styled(Badge)<StyledBadgeProps>`
  user-select: none;
    ${({ claimstatus }) => {
      switch (claimstatus) {
        case 'Submitted':
          return `
            > .ant-badge-count {
              ${borderedCss}
              background-color: var(--white);
              border-color: var(--success-color);
              color: var(--success-color);
            }
          `;
        case 'Progress':
          return `
            > .ant-badge-count {
              background-color: var(--success-color);
            }
          `;
        case 'Declined':
          return `
            > .ant-badge-count {
              background-color: var(--declined-color);
              color: var(--white);
            }
          `;
        case 'Completed':
          return `
            > .ant-badge-count {
              ${borderedCss}
              background-color: var(--white);
              border-color: var(--complete-color);
              color: var(--complete-color);
            }
          `;
        case 'Closed':
          return `
          > .ant-badge-count {
           ${borderedCss}
            background-color: #F2EEF8;
            color: #6633CC;
            border-color: #5A36B5;
          }
        `;
        case 'Pending':
          return `
            > .ant-badge-count {
              background-color: var(--error-color);
            }
          `;
        default:
          return;
      }
    }}
  }
`;

const ClaimBadge = ({ code, status, statusTc, styles }: ClaimBadgeProps): JSX.Element => {
  const { i18n } = useTranslation();
  return <StyledBadge style={styles} claimstatus={code} count={i18n.language == 'en' ? status : statusTc} />;
};

export default ClaimBadge;
